import { useLocationTestId } from '@/hooks/useTestId'
import localeText from '@/locales/datagrid'
import { TextField, TextFieldProps } from '@mui/material'
import { SearchIcon } from 'lucide-react'
import { GridFilterModelPro } from '../utils/filterModelPro'
import { useTableApiContext } from '../utils/table-context'

type Props = TextFieldProps & {
    disabled?: boolean
}

/**
 * Precisa estar no contexto do TableApiProvider
 */
export default function QuickFilter({ disabled, ...rest }: Props) {
    const {
        filterModelPro: { quickFilterValue = '' },
        onFilterModelChangePro,
    } = useTableApiContext()
    const quickFilterTestId = useLocationTestId('pesquisa-rapida')

    return (
        <NoContextQuickFilter
            disabled={disabled}
            quickFilterValue={quickFilterValue}
            onFilterModelChangePro={onFilterModelChangePro}
            {...rest}
            inputProps={{
                ...rest.inputProps,
                'data-testid': quickFilterTestId,
            }}
        />
    )
}

interface ContextValues {
    quickFilterValue: string
    onFilterModelChangePro: (
        updater: React.SetStateAction<GridFilterModelPro>,
    ) => void
}

export function NoContextQuickFilter({
    disabled,
    quickFilterValue,
    onFilterModelChangePro,
    ...rest
}: Props & ContextValues) {
    return (
        <TextField
            {...rest}
            sx={{
                ...rest.sx,
                ...(disabled && {
                    opacity: 0.3,
                }),
            }}
            InputProps={{
                ...rest.InputProps,
                startAdornment: (
                    <SearchIcon className="size-5 mr-2 opacity-75" />
                ),
            }}
            size="small"
            variant="outlined"
            autoComplete="off"
            placeholder={localeText.toolbarQuickFilterPlaceholder}
            disabled={disabled}
            defaultValue={quickFilterValue}
            onChange={event => {
                onFilterModelChangePro(prev => ({
                    ...prev,
                    quickFilterValue: event.target.value || '',
                }))
            }}
        />
    )
}
